module.exports = __webpack_public_path__ + "9e7480b0050fcacc6bde606eae4e5498.svg";